var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import EdButton from "../../../../../../web/components/generic/edbutton/edButton";
import InputField from "../../../../../../shared-library/components/inputField";
import { Col, Row } from "react-bootstrap";
import addFamilyMembers from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/addFamilyMembers.svg";
import { ENewFamilyFlowComponent } from "./ClientFamilies";
import clientDi from "../../di/serviceLocator";
import Loader from "@frameworks/shared-library/components/Loader";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
import debounce from "@frameworks/web/utils/debounce";
import { GenericDropdown, } from "@frameworks/shared-library/components/GenericDropdown";
var AddNewFamilyFlow = function (props) {
    var _a, _b, _c;
    var _d = __read(useState(false), 2), isAddMemberUiForNewFamily = _d[0], setIsAddMemberUiForNewFamily = _d[1];
    var _e = __read(useState(""), 2), searchText = _e[0], setSearchText = _e[1];
    var _f = __read(useState(""), 2), newFamilyName = _f[0], setNewFamilyName = _f[1];
    var _g = __read(useState(false), 2), familyNameError = _g[0], setFamilyNameError = _g[1];
    var _h = __read(useState(false), 2), showClientSearch = _h[0], setShowClientSearch = _h[1];
    var _j = __read(useState(""), 2), isError = _j[0], setIsError = _j[1];
    var _k = __read(useState(), 2), fieldError = _k[0], setFieldError = _k[1];
    var _l = __read(useState(), 2), familyMemberToBeAdded = _l[0], setFamilyMemberToBeAdded = _l[1];
    var _m = __read(useState([]), 2), familyMembersDetailArray = _m[0], setFamilyMembersDetailArray = _m[1];
    var _o = __read(useState([]), 2), relationShipDropdown = _o[0], setRelationShipDropdown = _o[1];
    var _p = __read(useState([]), 2), relationShipDropdownDetail = _p[0], setRelationShipDropdownDetail = _p[1];
    var _q = __read(useState([]), 2), clientSearchResult = _q[0], setClientSearchResult = _q[1];
    var _r = __read(useState(false), 2), searchLoader = _r[0], setSearchLoader = _r[1];
    var _s = __read(useState(true), 2), showFamilyWarning = _s[0], setShowFamilyWarning = _s[1];
    var _t = __read(useState(false), 2), isEdit = _t[0], setIsEdit = _t[1];
    var showAddMemberForNewFamily = function () {
        return (React.createElement("div", { className: "new-member d-flex align-items-center justify-content-center mt-4" },
            React.createElement("div", { className: "d-flex flex-column gap-4 text-center align-items-center" },
                React.createElement("span", { className: "DMSanN_18_400 txt_primaryGrey" }, "Please add at least one member to proceed with the family linking"),
                React.createElement("span", { className: "d-flex DMSans_16_500 txt-midnight-blue new-member-btn hand_cursor", onClick: function () {
                        if (newFamilyName) {
                            setIsAddMemberUiForNewFamily(true);
                            props === null || props === void 0 ? void 0 : props.setCurrentComponent(ENewFamilyFlowComponent.ADDMEMBER);
                        }
                        else {
                            setFamilyNameError(true);
                        }
                    } },
                    React.createElement("i", { className: "edel-icon-rounded-plus me-2" }),
                    "New Member"))));
    };
    var addedMemberDetailsTable = function () {
        return (React.createElement("div", { className: "add-new-family-details" },
            React.createElement("section", { className: "family-details-block" },
                React.createElement(Row, { className: "DMSanN_16_400 header-rows" },
                    React.createElement(Col, null, "UCC / Name"),
                    React.createElement(Col, null, "Relationship"),
                    React.createElement(Col, null, "Action")), familyMembersDetailArray === null || familyMembersDetailArray === void 0 ? void 0 :
                familyMembersDetailArray.map(function (detail, idx) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Row, { className: "details-row" },
                            React.createElement(Col, { className: "DMSans_13_400" }, detail === null || detail === void 0 ? void 0 :
                                detail.memberCode,
                                " ",
                                React.createElement("span", { className: "DMSans_16_500 ms-2" }, detail === null || detail === void 0 ? void 0 : detail.memberName)),
                            React.createElement(Col, { className: "DMSanN_16_400" }, getRelationship(detail === null || detail === void 0 ? void 0 : detail.relationshipId)),
                            React.createElement(Col, { className: "DMSanN_16_400 txt_redDark d-flex gap-2 position-relative" },
                                React.createElement("span", { className: "hand_cursor text-nowrap", onClick: function (e) {
                                        setIsEdit(true);
                                        handleEditMember(detail);
                                    } },
                                    React.createElement("i", { className: "edel-icon-edit-icon-large me-2" }),
                                    "Edit"),
                                React.createElement("span", { className: "hand_cursor text-nowrap", onClick: function (e) {
                                        e.stopPropagation();
                                        deleteFamilyMember(idx);
                                    } },
                                    React.createElement("i", { className: "edel-icon-delete-red1 me-2" }),
                                    "Delete")))));
                })),
            React.createElement(EdButton, { className: "add-member-btn", value: "Add New Member", btnTyp: "midnight-blue-border", onClick: function () {
                    props === null || props === void 0 ? void 0 : props.setCurrentComponent(ENewFamilyFlowComponent.ADDMEMBER);
                    setIsAddMemberUiForNewFamily(true);
                    setFamilyMemberToBeAdded(undefined);
                    setSearchText("");
                } })));
    };
    var addMemberRequiredFieldsUi = function () {
        var _a;
        return (React.createElement("div", { className: "add-members-details" },
            React.createElement(Row, { className: "mx-0 mb-4" },
                React.createElement(Col, null,
                    React.createElement("div", { className: "DMSanM_14_500 txt_primaryGrey mb-2" }, "Client Name"),
                    React.createElement("div", { className: "position-relative" },
                        React.createElement(InputField, { className: "DMSanN_16_400 client-name", placeholder: "Search client by Name", id: "name", name: "name", autoComplete: "off", type: "text", placeholderClassName: "", defaultValue: searchText, onChangeEvent: function (e) {
                                var _a;
                                setSearchText(e.target.value);
                                if (((_a = e.target.value) === null || _a === void 0 ? void 0 : _a.length) > 2) {
                                    setShowClientSearch(true);
                                    debounce(function () {
                                        getClientSearchResult(e.target.value);
                                    }, 500)();
                                }
                                else if (e.target.value == "") {
                                    setShowClientSearch(false);
                                    setClientSearchResult([]);
                                }
                                setIsError("");
                                setFieldError(__assign(__assign({}, fieldError), { memberName: "" }));
                            }, onBlur: function (error, event) { }, onKeyDown: function (e) { }, suffix: searchText ? (React.createElement("i", { className: "edel-icon-close hand_cursor", onClick: function () {
                                    setSearchText("");
                                    setClientSearchResult([]);
                                    setShowClientSearch(false);
                                    setIsError("");
                                    setFamilyMemberToBeAdded(function (prev) {
                                        var updatedVal = __assign(__assign({}, prev), { memberName: "", memberCode: "" });
                                        return updatedVal;
                                    });
                                } })) : (React.createElement("i", { className: "edel-icon-search1" })) }),
                        (fieldError === null || fieldError === void 0 ? void 0 : fieldError.memberName) && (React.createElement("span", { className: "DMSanN_16_400 red mt-1 d-flex" }, fieldError === null || fieldError === void 0 ? void 0 : fieldError.memberName)),
                        showClientSearch && (React.createElement("div", { className: "client-name-search-block" },
                            searchLoader && React.createElement(Loader, { className: "client-search-loader" }),
                            (clientSearchResult === null || clientSearchResult === void 0 ? void 0 : clientSearchResult.length) > 0 ? (clientSearchResult === null || clientSearchResult === void 0 ? void 0 : clientSearchResult.map(function (result) {
                                return (React.createElement("div", { className: "single-search-result d-flex justify-content-between align-items-center ".concat(!(result === null || result === void 0 ? void 0 : result.isDisabled) && "hover-state hand_cursor", " "), onClick: function (e) {
                                        e.stopPropagation();
                                        if (!(result === null || result === void 0 ? void 0 : result.isDisabled)) {
                                            setFieldError(__assign(__assign({}, fieldError), { memberName: "" }));
                                            setSearchText(result === null || result === void 0 ? void 0 : result.clientName);
                                            setFamilyMemberToBeAdded(function (prev) {
                                                var updatedVal = __assign(__assign({}, prev), { memberName: result === null || result === void 0 ? void 0 : result.clientName, memberCode: result === null || result === void 0 ? void 0 : result.uniqueCode });
                                                return updatedVal;
                                            });
                                            setShowClientSearch(false);
                                        }
                                    } },
                                    React.createElement("div", { className: "d-flex flex-column justify-content-center gap-1" },
                                        React.createElement("span", { className: "DMSanN_16_400 lh140 ".concat(result.isDisabled && "txt_dark_secondary-gray") }, result.clientName),
                                        React.createElement("span", { className: "Roboto_12_400  lh140 ".concat(result.isDisabled
                                                ? "txt-footer-darkgray"
                                                : "txt-DavySGray") }, (result === null || result === void 0 ? void 0 : result.isDisabled)
                                            ? "RM - " + result.dealerEmpName
                                            : "Your Client")),
                                    React.createElement("div", { className: "search-icon-block" }, !result.isDisabled ? (React.createElement("i", { className: "edel-icon-point-arrow-up txt-DavySGray" })) : (React.createElement(React.Fragment, null)))));
                            })) : (React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION })))))),
                React.createElement(Col, null,
                    React.createElement("div", { className: "DMSanM_14_500 txt_primaryGrey mb-2" }, "UCC (Auto Filled)"),
                    React.createElement(InputField, { className: "DMSanN_16_400", placeholder: "", id: "code", name: "code", autoComplete: "off", type: "text", placeholderClassName: "", defaultValue: (_a = familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberCode) === null || _a === void 0 ? void 0 : _a.toString(), onChangeEvent: function (e) { }, onBlur: function (error, event) { }, onKeyDown: function (e) { }, disabled: true }))),
            React.createElement(Row, { className: "mx-0 mt-2" },
                React.createElement(Col, { className: "relationship-col" },
                    React.createElement("div", { className: "DMSanM_14_500 txt_primaryGrey mb-2" }, "Relationship"),
                    React.createElement(GenericDropdown, { align: "start", id: "", externalClassname: "relationship-dropdown", defaultVal: false, callUseEffect: false, defaultText: "Select Relationship", itemlist: relationShipDropdown, selectedValue: function (e) {
                            setFamilyMemberToBeAdded(function (prev) {
                                var updatedVal = __assign(__assign({}, prev), { relationshipId: Number(e.value) });
                                return updatedVal;
                            });
                            setFieldError(__assign(__assign({}, fieldError), { relationship: "" }));
                            setIsError("");
                        } }),
                    (fieldError === null || fieldError === void 0 ? void 0 : fieldError.relationship) && (React.createElement("span", { className: "DMSanN_16_400 red mt-1 d-flex" }, fieldError === null || fieldError === void 0 ? void 0 : fieldError.relationship))),
                React.createElement(Col, null))));
    };
    var generateNewFamilyComponent = function () {
        switch (props === null || props === void 0 ? void 0 : props.currentComponent) {
            case ENewFamilyFlowComponent.CREATEFAMILY:
                return showAddMemberForNewFamily();
            case ENewFamilyFlowComponent.ADDMEMBER:
                return addMemberRequiredFieldsUi();
            case ENewFamilyFlowComponent.MEMBERDETAILS:
                return addedMemberDetailsTable();
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    var getRelationshipDropdown = function () {
        var _a;
        clientDi.clients
            .getFamilyRelations({ ucc: (_a = props === null || props === void 0 ? void 0 : props.selectedAcount) === null || _a === void 0 ? void 0 : _a.uniqueCode })
            .then(function (resp) {
            var _a, _b;
            setRelationShipDropdownDetail(resp === null || resp === void 0 ? void 0 : resp.data);
            var dropdown = ((_b = (_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.call(_a, function (val) {
                var _a;
                return ({
                    title: val === null || val === void 0 ? void 0 : val.relationshipName,
                    value: (_a = val === null || val === void 0 ? void 0 : val.relationshipId) === null || _a === void 0 ? void 0 : _a.toString(),
                });
            })) || [];
            setRelationShipDropdown(dropdown);
        })
            .catch(function (err) { });
    };
    var addMultipleMembersToFamily = function (familyID) {
        var payload = familyMembersDetailArray.map(function (member) {
            var _a;
            return (__assign(__assign({}, member), { familyId: familyID, headUcc: (_a = props === null || props === void 0 ? void 0 : props.selectedAcount) === null || _a === void 0 ? void 0 : _a.uniqueCode }));
        });
        clientDi.clients
            .createFamilyMemberMultiple(payload)
            .then(function (resp) {
            var _a;
            if (((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                props === null || props === void 0 ? void 0 : props.getFamilies();
                props === null || props === void 0 ? void 0 : props.setShowNewFamilyFlowPopup(false);
            }
            else {
                props === null || props === void 0 ? void 0 : props.setPopupLoader(false);
            }
        })
            .catch(function (err) {
            props === null || props === void 0 ? void 0 : props.setPopupLoader(false);
        });
    };
    var createFamily = function () {
        var _a, _b;
        props === null || props === void 0 ? void 0 : props.setPopupLoader(true);
        clientDi.clients
            .createFamily({
            familyHeadName: (_a = props === null || props === void 0 ? void 0 : props.selectedAcount) === null || _a === void 0 ? void 0 : _a.clientName,
            familyHeadUcc: (_b = props === null || props === void 0 ? void 0 : props.selectedAcount) === null || _b === void 0 ? void 0 : _b.uniqueCode,
            familyName: newFamilyName,
            headUcc: props === null || props === void 0 ? void 0 : props.selectedAcount.uniqueCode,
        })
            .then(function (resp) {
            var _a, _b, _c;
            if ((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.isFamilyCreated) {
                addMultipleMembersToFamily((_b = resp === null || resp === void 0 ? void 0 : resp.data) === null || _b === void 0 ? void 0 : _b.familyId);
            }
            else {
                setIsError((_c = resp === null || resp === void 0 ? void 0 : resp.data) === null || _c === void 0 ? void 0 : _c.errorMssg);
                props === null || props === void 0 ? void 0 : props.setPopupLoader(false);
            }
        })
            .catch(function (err) {
            props === null || props === void 0 ? void 0 : props.setPopupLoader(false);
        });
    };
    var checkForAddMemberValidation = function () {
        props === null || props === void 0 ? void 0 : props.setPopupLoader(true);
        clientDi.clients
            .createFamilyMember({
            memberCode: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberCode,
            memberName: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberName,
            relationshipId: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.relationshipId,
            familyId: 0,
            headUcc: props === null || props === void 0 ? void 0 : props.selectedAcount.uniqueCode,
        })
            .then(function (resp) {
            var _a, _b;
            if ((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.isMemberAdded) {
                setFamilyMembersDetailArray(function (prev) {
                    var existingIndex = prev.findIndex(function (member) {
                        return member.memberCode == familyMemberToBeAdded.memberCode ||
                            member.memberCode == familyMemberToBeAdded.editingMemberCode;
                    });
                    if (existingIndex !== -1) {
                        var updatedArray = __spreadArray([], __read(prev), false);
                        updatedArray[existingIndex] = {
                            memberCode: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberCode,
                            memberName: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberName,
                            relationshipId: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.relationshipId,
                            familyId: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.familyId,
                        };
                        return updatedArray;
                    }
                    return __spreadArray(__spreadArray([], __read(prev), false), [
                        {
                            memberCode: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberCode,
                            memberName: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberName,
                            relationshipId: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.relationshipId,
                            familyId: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.familyId,
                        },
                    ], false);
                });
                setIsAddMemberUiForNewFamily(false);
                props === null || props === void 0 ? void 0 : props.setCurrentComponent(ENewFamilyFlowComponent.MEMBERDETAILS);
                setFamilyMemberToBeAdded(undefined);
                setIsError("");
                setIsEdit(false);
            }
            else {
                setIsError((_b = resp === null || resp === void 0 ? void 0 : resp.data) === null || _b === void 0 ? void 0 : _b.errorMssg);
            }
            props === null || props === void 0 ? void 0 : props.setPopupLoader(false);
        })
            .catch(function (err) {
            props === null || props === void 0 ? void 0 : props.setPopupLoader(false);
        });
    };
    var getClientSearchResult = function (searchText) {
        var _a, _b;
        setSearchLoader(true);
        clientDi.clients
            .clientFamilySearch({
            searchText: searchText,
            individual: ((_a = props === null || props === void 0 ? void 0 : props.selectedAcount) === null || _a === void 0 ? void 0 : _a.pan)
                ? ((_b = props === null || props === void 0 ? void 0 : props.selectedAcount) === null || _b === void 0 ? void 0 : _b.pan[3].toUpperCase()) === "P"
                : true,
            page: 1,
            pageSize: 100,
        })
            .then(function (resp) {
            var _a;
            if (((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setClientSearchResult(resp === null || resp === void 0 ? void 0 : resp.data);
            }
            else {
                setClientSearchResult([]);
            }
            setSearchLoader(false);
        })
            .catch(function (err) {
            setClientSearchResult([]);
            setSearchLoader(false);
        });
    };
    var getRelationship = function (id) {
        var _a;
        return (((_a = relationShipDropdownDetail.find(function (item) { return item.relationshipId === id; })) === null || _a === void 0 ? void 0 : _a.relationshipName) || "");
    };
    var deleteFamilyMember = function (idx) {
        setFamilyMembersDetailArray(function (prev) {
            return prev.filter(function (_, index) { return index !== idx; });
        });
    };
    var handleOnClick = function () {
        if (isAddMemberUiForNewFamily) {
            if ((familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberName) &&
                (familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.relationshipId)) {
                if (!isEdit &&
                    (familyMembersDetailArray === null || familyMembersDetailArray === void 0 ? void 0 : familyMembersDetailArray.some(function (member) { return (member === null || member === void 0 ? void 0 : member.memberCode) === (familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberCode); }))) {
                    setIsError("Member already added");
                }
                else {
                    checkForAddMemberValidation();
                }
            }
            else {
                setFieldError({
                    memberName: (familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberName)
                        ? ""
                        : "This field is Required",
                    relationship: (familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.relationshipId)
                        ? ""
                        : "This field is Required",
                });
            }
        }
        else {
            if (newFamilyName === null || newFamilyName === void 0 ? void 0 : newFamilyName.trim()) {
                createFamily();
            }
            else {
                setFamilyNameError(true);
            }
        }
    };
    var handleEditMember = function (detail) {
        var _a, _b;
        var updatedDropdown = relationShipDropdownDetail
            .map(function (relation) {
            var _a;
            // Count how many members in `familyMembersDetailArray` match this `relationshipId`
            var memberCount = familyMembersDetailArray.filter(function (member) { return (member === null || member === void 0 ? void 0 : member.relationshipId) === (relation === null || relation === void 0 ? void 0 : relation.relationshipId); }).length;
            // Include the relationship only if the count is less than `maxCount`
            if (memberCount < (relation === null || relation === void 0 ? void 0 : relation.maxCount)) {
                return {
                    value: (_a = relation.relationshipId) === null || _a === void 0 ? void 0 : _a.toString(),
                    title: relation.relationshipName,
                };
            }
            return null; // Exclude relationships exceeding `maxCount`
        })
            .filter(Boolean); // Remove null values
        if (!((_a = updatedDropdown === null || updatedDropdown === void 0 ? void 0 : updatedDropdown.find(function (item) { var _a; return item.value == ((_a = detail.relationshipId) === null || _a === void 0 ? void 0 : _a.toString()); })) === null || _a === void 0 ? void 0 : _a.value)) {
            setRelationShipDropdown(__spreadArray(__spreadArray([], __read(updatedDropdown), false), [
                {
                    value: (_b = relationShipDropdownDetail === null || relationShipDropdownDetail === void 0 ? void 0 : relationShipDropdownDetail.find(function (item) { return item.relationshipId == detail.relationshipId; }).relationshipId) === null || _b === void 0 ? void 0 : _b.toString(),
                    title: relationShipDropdownDetail === null || relationShipDropdownDetail === void 0 ? void 0 : relationShipDropdownDetail.find(function (item) { return item.relationshipId == detail.relationshipId; }).relationshipName,
                },
            ], false));
        }
        setFamilyMemberToBeAdded(__assign(__assign({}, detail), { editingMemberCode: detail === null || detail === void 0 ? void 0 : detail.memberCode }));
        props === null || props === void 0 ? void 0 : props.setCurrentComponent(ENewFamilyFlowComponent.ADDMEMBER);
        setIsAddMemberUiForNewFamily(true);
        setSearchText(detail === null || detail === void 0 ? void 0 : detail.memberName);
    };
    useEffect(function () {
        getRelationshipDropdown();
    }, []);
    useEffect(function () {
        var _a, _b, _c;
        if ((_a = props === null || props === void 0 ? void 0 : props.selectedAcount) === null || _a === void 0 ? void 0 : _a.clientName) {
            setNewFamilyName("".concat(props.selectedAcount.clientName, " & Family ").concat(((_b = props === null || props === void 0 ? void 0 : props.familiesData) === null || _b === void 0 ? void 0 : _b.length) > 0 ? ((_c = props === null || props === void 0 ? void 0 : props.familiesData) === null || _c === void 0 ? void 0 : _c.length) + 1 : ""));
        }
    }, [props === null || props === void 0 ? void 0 : props.selectedAcount]);
    useEffect(function () {
        var updatedDropdown = relationShipDropdownDetail
            .map(function (relation) {
            var _a;
            // Count how many members in `familyMembersDetailArray` match this `relationshipId`
            var memberCount = familyMembersDetailArray.filter(function (member) {
                var _a, _b;
                return ((_a = member === null || member === void 0 ? void 0 : member.relationshipId) === null || _a === void 0 ? void 0 : _a.toString()) ===
                    ((_b = relation === null || relation === void 0 ? void 0 : relation.relationshipId) === null || _b === void 0 ? void 0 : _b.toString());
            }).length;
            // Include the relationship only if the count is less than `maxCount`
            if (memberCount < (relation === null || relation === void 0 ? void 0 : relation.maxCount)) {
                return {
                    value: (_a = relation.relationshipId) === null || _a === void 0 ? void 0 : _a.toString(),
                    title: relation.relationshipName,
                };
            }
            return null; // Exclude relationships exceeding `maxCount`
        })
            .filter(Boolean); // Remove null values
        setRelationShipDropdown(updatedDropdown);
    }, [familyMembersDetailArray]);
    return (React.createElement("div", { className: "add-family-member-block d-flex flex-column justify-content-between" },
        (props === null || props === void 0 ? void 0 : props.popupLoader) && React.createElement(Loader, null),
        React.createElement("div", null,
            (props === null || props === void 0 ? void 0 : props.currentComponent) === ENewFamilyFlowComponent.MEMBERDETAILS &&
                showFamilyWarning && (React.createElement("div", { className: "bg-ivory py-2 px-3 DMSansNormal_12_400 txt_blue-tint mb-3 d-flex justify-content-between new-family-warning" },
                React.createElement("div", { className: "d-flex align-items-center" },
                    React.createElement("i", { className: "edel-icon-attention-icon me-3" }), (_c = (_b = (_a = props.selectedAcount) === null || _a === void 0 ? void 0 : _a.clientName) === null || _b === void 0 ? void 0 : _b.split(" ")) === null || _c === void 0 ? void 0 :
                    _c[0],
                    "\u2019s position as the family head is fixed. The only way to change is by deleting and for the respective head to recreate the family."),
                React.createElement("div", { onClick: function () {
                        setShowFamilyWarning(false);
                    } },
                    React.createElement("i", { className: "edel-icon-close txt-nuvamaBlue hand_cursor" })))),
            React.createElement("div", { className: "family-name pb-2 position-relative" },
                React.createElement("div", { className: "DMSanN_16_400 txt_primaryGrey mb-2" }, "Family Name"),
                React.createElement(InputField, { className: "DMSanN_16_400 txt-midnight-blue  ".concat(isAddMemberUiForNewFamily && "disabled-name-field"), placeholder: "Enter name", id: "name", name: "name", autoComplete: "off", type: "text", placeholderClassName: "", defaultValue: newFamilyName, onChangeEvent: function (e) {
                        setNewFamilyName(e.target.value);
                        setFamilyNameError(false);
                    }, onBlur: function (error, event) { }, onKeyDown: function (e) { }, errorText: "", disabled: isAddMemberUiForNewFamily }),
                familyNameError && (React.createElement("span", { className: "DMSanN_16_400 red mt-1 d-flex" }, "Please fill out this field")),
                !isAddMemberUiForNewFamily && (React.createElement("img", { src: addFamilyMembers, alt: "Add Member" }))),
            generateNewFamilyComponent()),
        React.createElement("div", null,
            isError && (React.createElement("div", { className: "DMSanN_16_400 txt-lightCarminePink mb-4 pb-2" }, isError)),
            React.createElement("div", { className: "d-flex justify-content-end gap-4 add-member-btn-block" },
                React.createElement(EdButton, { value: isAddMemberUiForNewFamily ? "Back" : "Cancel", btnTyp: "midnight-blue-border", onClick: function () {
                        if (isAddMemberUiForNewFamily) {
                            if ((familyMembersDetailArray === null || familyMembersDetailArray === void 0 ? void 0 : familyMembersDetailArray.length) > 0) {
                                props === null || props === void 0 ? void 0 : props.setCurrentComponent(ENewFamilyFlowComponent.MEMBERDETAILS);
                                setIsEdit(false);
                                setIsError("");
                            }
                            else {
                                props === null || props === void 0 ? void 0 : props.setCurrentComponent(ENewFamilyFlowComponent.CREATEFAMILY);
                            }
                            setIsAddMemberUiForNewFamily(false);
                        }
                        else {
                            props === null || props === void 0 ? void 0 : props.setShowNewFamilyFlowPopup(false);
                        }
                    } }),
                React.createElement(EdButton, { value: isAddMemberUiForNewFamily ? "Add" : "Create", btnTyp: "midnight-blue", onClick: function () {
                        handleOnClick();
                    }, disabled: ((familyMembersDetailArray === null || familyMembersDetailArray === void 0 ? void 0 : familyMembersDetailArray.length) === 0 &&
                        !isAddMemberUiForNewFamily) ||
                        !!isError })))));
};
export default AddNewFamilyFlow;
